module.exports = __webpack_public_path__ + "img/DE00791.ec13a210.png";